export type HistoryScoreTone = 'red' | 'orange' | 'green';

export const getHistoryScoreTone = (score: number): HistoryScoreTone => {
  const normalized = Number.isFinite(score) ? score : 0;
  if (normalized <= 60) return 'red';
  if (normalized <= 80) return 'orange';
  return 'green';
};

export const getHistoryScoreTextClass = (score: number) => {
  const tone = getHistoryScoreTone(score);
  if (tone === 'red') return 'text-red-600';
  if (tone === 'orange') return 'text-orange-600';
  return 'text-green-600';
};

export const getHistoryScoreCardClass = (score: number) => {
  const tone = getHistoryScoreTone(score);
  if (tone === 'red') return 'border-red-400 ring-2 ring-red-200';
  if (tone === 'orange') return 'border-orange-400 ring-2 ring-orange-200';
  return 'border-green-500 ring-2 ring-green-300';
};

export const getHistoryScorePanelClass = (score: number) => {
  const tone = getHistoryScoreTone(score);
  if (tone === 'red') return 'border-red-200 bg-red-50';
  if (tone === 'orange') return 'border-orange-200 bg-orange-50';
  return 'border-green-200 bg-green-50';
};

